function blacklist() {
  
  this.start = start;
  this.validate = validate;
  this.lists = [];
  this.referrer = document.referrer;
  this.urlSearch = document.location.search;

  async function start() {
    const safeAccess = JSON.parse(sessionStorage.getItem('safeAccess'));
    if(safeAccess === false) {
      console.log(`bl - not safe access`);
      return false
    }

    let bl = window.blmeta || JSON.parse(sessionStorage.getItem('blist'));
    // if(!bl) {
    //   const response = await fetch('https://api2.rmdy-brands.link/db/rmdy/blacklist', {
    //     headers:{'x-api-key': '02Hd6xE1um4HeWG34qY4z9j3z59z2sGZ71AfujEd' }
    //   }).catch(er => {
    //     if (window.location.href.indexOf('/pages/landing-redness') > -1 || window.location.href.indexOf('lp-b') > -1) {
    //       window.location = 'https://riversol.com/products/sample-kit-redness';
    //       return;
    //     }
    //     if (window.location.href.indexOf('/pages/landing') > -1 || window.location.href.indexOf('lp-a/') > -1) {
    //       window.location = 'https://riversol.com/products/sample-kit';
    //       return;
    //     }
    //   })
    //   bl = await response.json();
    //   sessionStorage.setItem('blist', JSON.stringify(bl));
    // }

    this.lists = bl;
    const valid = this.validate();
    sessionStorage.setItem('safeAccess', valid);
    console.log(`bl - ${valid ? 'safe' : 'not safe'} access`);

    // On product page
    // {% comment %} update to paid samples without refreshing page on /sample-kit and /sample-kit-redness {% endcomment %}
    if (!valid && typeof updateSample == 'function') updateSample(); 
  }

  function validate() {

    const blDomain = this.lists.domains.map(d => d.domain).find(domain => this.referrer.indexOf(domain) > -1);
    const blString = this.lists.strings.map(d => d.string).find(string => this.urlSearch.indexOf(string) > -1);
    
    return !(blDomain || blString);

  }
  
}


window.blacklist = new blacklist();
window.blacklist.start();


// redirect
if(window.location.href.indexOf('/collections/types?q=sample') > -1) {
  window.location.assign('https://www.riversol.com/collections/all');
}
if(window.location.href.indexOf('best=Beverly') > -1) {
  window.location.assign(window.location.pathname);
}